var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-side-icon',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.download}},[_c('v-icon',[_vm._v("arrow_downward")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }